import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { ApiInterfaceService } from '../api-interface.service';

/**
 * This service will have sendbird connection graphQL queries/mutations
 */
@Injectable({
  providedIn: 'root',
})
export class SbConnectionGqlService {
  constructor(private api: ApiInterfaceService) {}

  /**
   * Generate sendbird access token.
   *
   * @param clientUid - this is used to connect to sendBird on behalf of another user. for example, quick actions in coordinator workflow.
   */
  async generateSendbirdSessionToken(clientUid?: string): Promise<any> {
    try {
      const resChannel = await this.api.gqlMutation(
        gql`
          mutation generateSendbirdSessionToken(
            $generateSendbirdSessionTokenInput: GenerateSendbirdSessionTokenInput!
          ) {
            generateSendbirdSessionToken(input: $generateSendbirdSessionTokenInput) {
              userSessionToken {
                sessionToken
              }
            }
          }
        `,
        { generateSendbirdSessionTokenInput: { clientUid } },
      );

      return resChannel['generateSendbirdSessionToken']?.userSessionToken?.sessionToken;
    } catch (e) {
      console.error('generateSendbirdSessionToken', e);
      return Promise.reject(e);
    }
  }
}
